import React, { Fragment } from "react";
import FlexBox from "../FlexBox/FlexBox";
import Typography from "../../Foundation/Typography/Typography";
import Dropdown, { IDropdownProps } from "../../Core/Dropdown/Dropdown";
import Link from "../../Core/Link/Link";
import Divider from "../Divider/Divider";
import useBreakpoint from "../Grid/hooks/useBreakpoint";
import SimpleBar from "../../lib/simplebar/LazySimpleBar";

export interface ICarteItem {
  label: string;
  title_color?: string | null;
  url?: string;
  onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

export interface ICarteSection {
  label: string;
  links: ICarteItem[];
}

export interface ICarteDropdownProps {
  label?: string;
  list?: ICarteSection[];
  onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  url?: string;
  className?: string;
  beforeClick?: () => Promise<void>;
  onVisibleChange?: IDropdownProps["onVisibleChange"];
}

const CarteDropdown = (props: ICarteDropdownProps) => {
  const {
    label = "Carte",
    list = [],
    onClick: onClickMenu,
    url: urlMenu,
    className,
    onVisibleChange,
    beforeClick,
  } = props;
  const { isMobileAndMd } = useBreakpoint();

  const renderedLink = (
    <Link
      className={className}
      color="white"
      url={urlMenu}
      label={label}
      onClick={onClickMenu}
      beforeClick={beforeClick}
    />
  );

  if (isMobileAndMd) {
    onVisibleChange?.(false);
    return renderedLink;
  }
  return (
    <Dropdown
      trigger="hover"
      popupVisible={isMobileAndMd ? false : undefined}
      contentStyle={{ transform: "translateY(24px)" }}
      onVisibleChange={onVisibleChange}
      content={
        <SimpleBar
          style={{
            width: "345px",
            maxHeight: "calc(90vh - 100px)",
            overflowY: "auto",
          }}
        >
          {list.map(({ label, links }, index) => (
            <Fragment key={label}>
              {index > 0 && (
                <Divider mt={16} mb={21} weight={1} direction="horizontal" />
              )}
              <FlexBox direction="column" gap={16}>
                <Typography variant="h6" color="champagne7" cursor="default">
                  {label}
                </Typography>

                <FlexBox direction="column" gap={7}>
                  {links.map(
                    ({ label: linkLabel, url, title_color, onClick }) => {
                      return (
                        <Link
                          key={linkLabel}
                          label={linkLabel}
                          variant="h7"
                          color="black"
                          url={url}
                          onClick={onClick}
                          style={{ color: title_color || undefined }}
                        ></Link>
                      );
                    }
                  )}
                </FlexBox>
              </FlexBox>
            </Fragment>
          ))}
        </SimpleBar>
      }
    >
      {renderedLink}
    </Dropdown>
  );
};

export default CarteDropdown;
